import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/About.scss';

const About = () => {
  return (
    <div className="about">
      <section className="hero">
        <h1>About Omorsoft</h1>
        <p>We're passionate about creating digital experiences that make a difference</p>
      </section>

      <div className="about-content">
        <section className="mission">
          <h2>Our Mission</h2>
          <p>Our mission is to create digital tools that make life simpler, more organized, and more empowering for people with specialized passions or responsibilities. By focusing on education, care, and management, we help communities thrive through technology that supports their goals and wellbeing.</p>
        </section>

        <section className="cards">
          <h2>Our Values</h2>
          <div className="cards-grid">
            <div className="card">
              <h3>Innovation</h3>
              <p>Pushing boundaries and exploring new possibilities in technology</p>
            </div>
            <div className="card">
              <h3>Quality</h3>
              <p>Delivering excellence in every line of code and every interaction</p>
            </div>
            <div className="card">
              <h3>Collaboration</h3>
              <p>Working together to achieve extraordinary results</p>
            </div>
          </div>
        </section>

        <section className="expertise">
          <h2>Our Expertise</h2>
          <p>
            With years of experience in mobile and web development, we've mastered the art of
            creating seamless, intuitive, and powerful applications. Our team of skilled developers
            and designers work together to bring ideas to life.
          </p>
        </section>
      </div>
    </div>
  );
};

export default About; 